import React, { useState, useEffect } from 'react';
import HourlyForecast from './components/HourlyForecast';
import WeeklyForecast from './components/WeeklyForecast';
import FullWeeklyForecast from './components/FullWeeklyForecast';

const WeatherHome = ({ weather, title }) => {
  const days = [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const today = new Date();
  const tDate = new Date().getDate();
  const tMonth = today.toLocaleDateString('default', {month: 'long'});
  const tYear = today.getFullYear();
  const sevenHours = HourlyWeather();

  const [daySelected, daySelectedUpdate] = useState(null);

  function LiveClock() {
    const [time, setTime] = useState(new Date());
  
    useEffect(() => {
      const intervalId = setInterval(() => {
        setTime(new Date());
      }, 1000);
      return () => clearInterval(intervalId);
    }, []);
  
    return (
      time.toLocaleTimeString()
    );
  }

  function HourlyWeather() {
    const currentHour = today.getHours() < 10 ? "0" + today.getHours() + ":00:00" : today.getHours() + ":00:00";
    const nextSevenHours = [];
    var index = 0;
    var startAdd = false;
    
    for (var hour of weather.days[0].hours) {
      if(hour.dateTime === currentHour) {
        startAdd = true;
      } else if (startAdd === true && index !== 7) {
        index++;
        nextSevenHours.push(hour);
      }
    }
    return nextSevenHours
  }

  const handleClick = (index) =>  {
    daySelectedUpdate(index);
  }

    return ( 
      <div className="m-auto container align-top px-4">
        {/* -- Location Search Start -- */}
        {/* <div className="p-4 rounded-lg md:bg-white md:bg-opacity-5 md:shadow-md grow mb-6 mt-2">
          <div className='relative inline-flex items-center w-full'>
            <Icon color={'white'} className='h-6 w-6 absolute left-5 opacity-80' path={ inputValue !== '' ? mdiMapMarker : mdiMagnify} size={0.85} />
            <input 
              className='
                w-full mx-2 bg-white text-white bg-opacity-10 rounded-full h-10 px-9
              placeholder-white placeholder-opacity-80 
                focus-visible:outline-none focus-visible:text-opacity-100' 
              type='text' 
              placeholder='Enter a town, city or postcode...' 
              value={inputValue} 
              onChange={ (e) => inputValueUpdate(e.target.value)} 
              onKeyDown={handleKeyDown} 
            />
            { inputValue !== '' && 
              <button className='absolute inline-flex items-center right-10' onClick={handleClear}>
                <Icon color={'white'} className='h-6 w-6 absolute opacity-80' path={mdiClose} size={0.85} />
              </button> 
            }
          </div>
        </div>
        */}
        {/* -- Location Search End -- */}

        <div className="m-auto container mx-auto p-4 rounded-lg md:bg-white md:bg-opacity-5 md:shadow-md grow mb-2">

          {/* -- Location & Date/Time Start -- */}
          <div className="py-3 px-4 m-2 text-center">
            <h1 className="text-3xl">{ title }</h1>
            <span className="mb-0 mr-2 text-lg">{ days[new Date().getDay()] },</span>
            <span className="mb-0 text-lg">{ tDate } </span>
            <span className="mb-0 text-lg">{ tMonth } </span>
            <span className="mb-0 text-lg">{ tYear }</span>
            <span className="text-lg"> | { LiveClock() }</span>
          </div>
          {/* -- Location & Date/Time End -- */}

          <div 
            className="
              justify-between py-4 px-4 my-6 m-2 
              md:flex md:flex-row
            "
          >
            {/* -- Weather Temperature and Description Start -- */}
            <div className='flex grow md:basis-1/3 md:mr-4 md:mb-0'>
              <div className='basis-1/2 mr-2 self-center'>
                <img className='flex' alt='hail' src={require('./icons/' + weather.days[0].icon + ".png")} width="128px" height="128px"/>
              </div>
              <div className='self-center md:basis-2/3'>
                <span className="text-4xl">{ weather.days[0].temp }</span>
                <span className='text-3xl'> °c</span>
                <p className='ml-1 text-md'>{ weather.days[0].description } </p>
              </div>
            </div>
            {/* -- Weather Temperature and Description End -- */}

            <br className='md:hidden'/>
            <br className='md:hidden'/>
            
            {/* -- Weather General Stats Start -- */}
            <div className=' basis-1/2 flex flex-row flex-wrap md:ml-8 md:pl-8 justify-end'>
              <div className='grow basis-1/3 text-center self-center mb-6'>
                <span className="text-xl">{ weather.days[0].tempMax }</span>
                <span className='text-md'> °c</span>
                <p className="text-center">Max Temp</p>
              </div>
              <div className='grow basis-1/3 text-center self-center mb-6' >
                <span className="text-xl">{ weather.days[0].sunrise.slice(0, -3) }</span>
                <p>Sunrise</p>
              </div>
              <div className='grow basis-1/3 text-center self-center mb-6'>
                <span className="text-xl">{ weather.days[0].humidity }</span>
                <span className='text-xl'>%</span>
                <p className="text-center">Humidity</p>
              </div>
              <div className='grow basis-1/3 text-center self-center'>
                <span className="text-xl">{ weather.days[0].tempMin }</span>
                <span className='text-md'> °c</span>
                <p className="text-center text-md">Min Temp</p>
              </div>
              <div className='grow basis-1/3 text-center self-center' >
                <span className="text-xl">{ weather.days[0].sunset.slice(0, -3) }</span>
                <p>Sunset</p>
              </div>
              <div className='grow basis-1/3 text-center self-center'>
                <span className="text-xl">{ weather.days[0].precipProb == null ? 0 : weather.days[0].precipProb }</span>
                <span className='text-xl'>%</span>
                <p className="text-center">Rain</p>
              </div>
            </div>
            {/* -- Weather General Stats End -- */}
          </div>

          { <HourlyForecast hourlyForecast={sevenHours}/> }
          { daySelected == null && <WeeklyForecast weeklyWeather={weather} weekDays={days} handleClick={handleClick}/> }
          { daySelected != null && <FullWeeklyForecast fullWeeklyWeather={weather.days[daySelected]} days={days} handleClick={handleClick}/> }
          
        </div>
      </div>
    );
}
 
export default WeatherHome;